import axios from "../axios";

import {
  AUTH_FETCHING_DATA,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  COMPANIES_INDEX,
  PROJECT_INDEX,
} from "../typesAction";

import project_filters from "../prototyping/configuration/filter/project.json";
import company_filters from "../prototyping/configuration/filter/company.json";

export default ({ dispatch, getState }) => (next) => (action) => {
  const state = getState();

  /* https://stackoverflow.com/questions/54531731/how-to-refresh-jwt-tokens-in-react-js-application
     The process is something like

     Checking if the error status is 401
     If there is a valid refresh token: use it to get the access token
     if there is no valid refresh token: log the user out and return
     Redo the request again with the new token.  */

  if (
    state.auth.isAuth !== "false" &&
    state.auth.isAuth &&
    action.payload &&
    action.payload.response &&
    action.payload.response.status === 401
  ) {
    //check do we already send refresh token
    console.log('Axios middleware received 401');

    if (!state.auth.refreshToken) {
      console.log('No refresh token, logging out');
      logout();

      dispatch({ type: AUTH_LOGOUT, payload: "" });
    } else {
      // Is this block still being used?
      console.log('Have refresh token, acquire new access token');

      dispatch({ type: AUTH_FETCHING_DATA, payload: true });

      axios
        .post(`/token/refresh`, {
          refresh_token: state.auth.refreshToken,
        })
        .then(function (response) {
          localStorage.setItem("access_token", response.data.token);
          localStorage.setItem("refresh_token", response.data.refresh_token);
          localStorage.setItem("isAuth", true.toString());

          dispatch({ type: AUTH_LOGIN, payload: response.data });

          action.payload.config.headers.Authorization = `Bearer ${response.data.token}`;

          axios.request(action.payload.config).then(function (response) {
            let payload;

            switch (action.payload.type) {
              case PROJECT_INDEX:
                payload = {
                  data: response.data,
                  filters: project_filters,
                };
                break;
              case COMPANIES_INDEX:
                payload = {
                  data: response.data,
                  filters: company_filters,
                };
                break;

              default:
                payload = response.data;
                break;
            }

            dispatch({
              type: action.payload.type,
              payload: payload,
            });
          });
        })
        .catch(function () {
          logout();
          dispatch({ type: AUTH_LOGOUT, payload: "" });
        });
    }
  } else {
    console.debug('Axios Middelware, skipping');
    return next(action);
  }
};

function logout() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("isAuth");
  localStorage.removeItem("selectedTenant");
}
